import React, { Component } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default class IconButton extends Component {

    getIcon(){

        if(this.props.icon == "file-pdf"){
            return <div className={`image-icon pdf ${this.props.size || ""}`}></div>;
        }
        if(this.props.icon == "file-excel"){
            return <div className={`image-icon excel ${this.props.size || ""}`}></div>;
        }

        return <FontAwesomeIcon
            icon={this.props.icon}
            size={this.props.size ? this.props.size : "sm"}
            className="iconbutton--icon"
        />

    }

    handleClick = () => {
        if (!this.props.disabled) {
            this.props.onClick();
        }
    };
 
    render() {
        return (
            <div className={this.props.disabled ? "iconbutton disabled" : "iconbutton"} onClick={this.handleClick} disabled={this.props.disabled}>
                {this.getIcon()}
                
                {this.props.text && <span className="iconbutton--text">{this.props.text}</span>}
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/modules/comum/components/IconButton.js